import _ from 'lodash';
import { SetupInstance } from '../../app/msal-account-helpers';
import { protectedResources } from '../../authConfig';
import { InteractionRequiredAuthError, InteractionStatus } from '@azure/msal-browser';
import { useLocal } from './../environment';
import { hydrateObjects, cleanUpJsonForTransport } from '../json-helper';
import polly from 'polly-js';
import { filterByApplicationAreas } from './doc-functions';
import { AccessTokenHelper } from '../access-token-helper';

import { msalConfig } from '../../app';

export class DocsAPI {
    constructor(instance, inProgress, accounts, forceRefresh) {

        this.instance = SetupInstance(instance);
        this.inProgress = inProgress;
        this.account = accounts[0];

        this.accessTokenRequest = {
            scopes: [
                ...protectedResources.apiProperty.scopes.read
            ],
            authority: `https://login.microsoftonline.com/${msalConfig.auth.tenantId}/`,
            forceRefresh: forceRefresh,
            account: this.account,
        };

        this.russetPropertiesFilesApi = useLocal ?
            'http://localhost:8081/api/files/' :
            'https://apim.ianrobertson.co.uk/api/files/v1/';

        this.accessTokenService = new AccessTokenHelper();
    }

    static formats = []; // local cache
    static systemDocTypes = []; // local cache

    #getFormatFromCache = key => {

        const format = _.find(DocsAPI.formats, f => f && f.key === key);
        return format;
    }

    #addFormatToCache = format => {

        const existingFormat = this.#getFormatFromCache(format.key);
        if (!existingFormat) {
            DocsAPI.formats.push(format);
        }
        else {
            // replace the whole format...
            const existingFormatIndex = _.findIndex(DocsAPI.formats, f => f && f.key === format.key);
            DocsAPI.formats.splice(existingFormatIndex, 1); // Remove current version
            DocsAPI.formats.splice(existingFormatIndex, 0, format); // Insert new version in its place
        }
    }

    #addFormatsToCache = formats => {

        for (const format of formats) {
            this.#addFormatToCache(format);
        }
    }

    #getDocTypeFromCache = documentType => {

        const format = _.find(DocsAPI.docTypes, f => f && f.documentType === documentType);
        return format;
    }

    #addDocTypeToCache = docType => {

        const existingDocType = this.#getDocTypeFromCache(docType.documentType);
        if (!existingDocType) {
            DocsAPI.systemDocTypes.push(docType);
        }
        else {
            // replace the whole format...
            const existingDocTypeIndex = _.findIndex(DocsAPI.docTypes, d => d && d.documentType === docType.documentType);
            DocsAPI.systemDocTypes.splice(existingDocTypeIndex, 1); // Remove current version
            DocsAPI.systemDocTypes.splice(existingDocTypeIndex, 0, docType); // Insert new version in its place
        }
    }

    #addDocTypesToCache = docTypes => {

        for (const docType of docTypes) {
            this.#addDocTypeToCache(docType);
        }
    }

    getAll = (applicationAreas) => {

        return polly()
            .logger(error => {
                console.error("An error occurred in getFileStructure", error); // will be hit 5 times if issues
            })
            .waitAndRetry(5)
            .executeForPromise(() => {
                return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars 

                    if (this.inProgress !== InteractionStatus.None) {
                        return this.instance.acquireTokenSilent(this.accessTokenRequest);
                    }

                    this.accessTokenService.getAccessToken(this.instance, this.inProgress, this.accessTokenRequest)
                        .then(accessTokenResponse => {

                            if (!!!accessTokenResponse) {
                                return reject("No access token");
                            }

                            const bearer = `Bearer ${accessTokenResponse.accessToken}`;

                            const headers = new Headers();
                            headers.append("Authorization", bearer);
                            headers.append("Content-Type", "application/json");

                            const options = {
                                method: "GET",
                                headers: headers
                            };

                            const url = new URL(`${this.russetPropertiesFilesApi}GetFileTypeData`);

                            fetch(url, options)
                                .then(response => {
                                    if (response.ok) return response.json();
                                    return reject(response);
                                })
                                .then(data => {

                                    const result = cleanUpJsonForTransport(Object.assign({}, hydrateObjects(data)));

                                    this.#addFormatsToCache(result.formats);
                                    this.#addDocTypesToCache(result.documentTypes);

                                    return resolve({ formats: result.formats, documentTypes: filterByApplicationAreas(applicationAreas, result.documentTypes) });
                                })
                                .catch(error => {
                                    console.log(error);
                                    return reject(error)
                                });
                        })
                        .catch((error) => {
                            if (error instanceof InteractionRequiredAuthError) {
                                // Let centralized auth handling manage redirects
                            }
                            console.log(error);
                            return reject(error)
                        });
                });
            });
    };

}